import React, {Component} from 'react';
import {
    Button, withStyles, MobileStepper,
} from "@material-ui/core";
import {bindActionCreators, compose} from "redux";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {push} from "react-router-redux";
import SwipeableViews from 'react-swipeable-views';

import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import RegisterStart from './Start';
import RegisterPush from './Push';
import RegisterPushRequest from '../PushRequest';
import RegisterError from './Error';
import RegisterSuccess from '../Success';

const styles = theme => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'stretch',
        paddingBottom: 54,
    },
    logo: {
        flex: 1,
        width: '100%',
        maxHeight: 250,
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,

        backgroundImage: 'url(' + require('../../resources/logo/full.png') + ')',
        backgroundSize: 'contain',
        backgroundPosition: '0% 50%',
        backgroundRepeat: 'no-repeat',
    },
    content: {
        padding: theme.spacing.unit * 2,
    },
    swipeContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    stepperRoot: {
        flexGrow: 1,
    },
});

class Register extends Component {

    constructor(props) {
        super(props);

        this.methodIndex = {
            'push': 1,
            'sms': 1,
            'facebook': 1,
            'success': 3,
            'error': 4,
        };

        const index = this.indexFromUrl(props);
        this.state = {
            activeStep: index >= 0 ? index : 0,
            method: 'messenger',
            error: null,
        };
    }

    indexFromUrl(props = this.props) {
        if (!props.match.params.method) {
            return 0;
        } else if (props.match.params.method === 'push' && props.match.params.data === 'verify') {
            return this.methodIndex.push + 1;
        } else if (props.match.params.method in this.methodIndex) {
            return this.methodIndex[props.match.params.method];
        } else {
            return -1;
        }
    }

    componentWillReceiveProps(nextProps) {
        try {
            console.log("PROPS", this.props, nextProps);
            if (this.props.match.params.method !== nextProps.match.params.method) {
                const index = this.indexFromUrl(nextProps);
                if (index >= 0) {
                    this.handleChangeIndex(index);
                }
            }
        } catch (e) {
            console.debug("componentWillReceiveProps ignored error", e, this.props, nextProps);
        }
    }

    handleChange(name) {
        return event => this.setState({[name]: event.target.value});
    }

    handleChangeChecked(name) {
        return event => this.setState({[name]: event.target.checked});
    }

    handleNext() {
        switch (this.state.activeStep) {
            case 0:
                return this.props.push('/register/' + this.state.method);
            case 1:
                return this.props.push('/register/push/verify');
            case 2:
                return this.props.push('/register/success');
            case this.methodIndex.success:
                return null;
            default:
                return this.setState({activeStep: this.state.activeStep + 1});
        }
    }

    handleBack() {
        switch (this.state.activeStep) {
            case 1:
            case this.methodIndex.error:
                return this.props.push('/register');
            default:
                return this.setState({activeStep: this.state.activeStep - 1});
        }
    }

    handleChangeIndex(index) {
        this.setState({activeStep: index});
    }

    handlePushFail(code) {
        return this.props.push('/register/error/' + code)
    }

    getNextText() {
        switch (this.state.activeStep) {
            default:
                return 'Nästa';
            case 0:
                return 'Acceptera';
            case 1:
                return 'Tillåt notiser';
            case this.methodIndex.success:
                return 'Surfa';
        }
    }

    getBackText() {
        switch (this.state.activeStep) {
            default:
                return 'Tillbaks';
            case 1:
                return 'Ändra metod';
            case 2:
                return 'Avbryt';
            case this.methodIndex.error:
                return 'Börja om';
        }
    }

    render() {
        const {classes, theme, toUrl} = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.content}>
                    <SwipeableViews index={this.state.activeStep} onChangeIndex={this.handleChangeIndex.bind(this)}
                                    disabled>
                        <div className={classes.swipeContainer}>
                            <RegisterStart value={this.state.method} onChange={(method) => this.setState({method})}/>
                        </div>
                        <div className={classes.swipeContainer}>
                            <RegisterPush/>
                        </div>
                        <div className={classes.swipeContainer}>
                            <RegisterPushRequest
                                active={this.state.activeStep === 2 && this.state.method === 'push'}
                                onSuccess={this.handleNext.bind(this)}
                                onError={this.handlePushFail.bind(this)}
                            />
                        </div>
                        <div className={classes.swipeContainer}>
                            <RegisterSuccess/>
                        </div>
                        <div className={classes.swipeContainer}>
                            <RegisterError code={this.props.match.params.data}/>
                        </div>
                    </SwipeableViews>
                </div>
                <MobileStepper
                    variant="dots"
                    steps={4}
                    activeStep={this.state.activeStep}
                    className={classes.stepperRoot}
                    nextButton={
                        <Button size="small" color="secondary" onClick={this.handleNext.bind(this)}
                                {...(this.state.activeStep === this.methodIndex.success ? {
                                    component: 'a',
                                    target: '_blank',
                                    rel: 'noopener',
                                    href: typeof toUrl !== 'string' || toUrl.length <= 1 || toUrl.indexOf('connectivitycheck') ? 'https://google.se/' : toUrl
                                } : {})}
                                style={{opacity: this.state.activeStep >= 2 && this.state.activeStep !== 3 ? 0 : 1}}>
                            {this.getNextText()}
                            {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                        </Button>
                    }
                    backButton={
                        <Button size="small" color="secondary" onClick={this.handleBack.bind(this)}
                                disabled={this.state.activeStep <= 0 || this.state.activeStep > 2}
                                style={{opacity: this.state.activeStep <= 0 || this.state.activeStep > 2 ? 0 : 1}}>
                            {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                            {this.getBackText()}
                        </Button>
                    }
                />
            </div>
        );
    }
}

Register.propTypes = {};

const mapStateToProps = (state) => ({
    toUrl: state.wifi.url,
});
const mapDispatchToProps = dispatch => bindActionCreators({
    push,
}, dispatch);

export default compose(
    withRouter,
    withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps),
)(Register);



// WEBPACK FOOTER //
// ./src/containers/Register/index.js